module.exports = __webpack_public_path__ + "img/bg.9d351d21.jpg";